import {
  getPaymentCalculatorDiscountPromotion,
  getSpecialCases,
} from "../../../helpers/tools";

export function latinAmericaEuropeDiscountsVET(
  data,
  paymentType,
  courses,
  specialCases
) {
  const allSpecialCasesAvailable = getSpecialCases(data, courses);

  for (let i = 0; i < courses.length; i++) {
    const course = courses[i];
    // Default finalTuition, change if have discount
    course.finalTuition = course?.tuition;
    course.discountsApplied = [];
  }
  console.debug("Courses after discounts were applied:", courses);
}
